/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'jquery',
	'../../../../widgets/livewidget/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/ui/dialogs/ConfirmationDialog',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (_, $, resources, ConfirmationDialog, ReactDOM, React, Toolkit, PropTypes) {

	const { Dialog,
		TruncatedText,
		ListItem,
		Container,
		SVGIcon,
		List,
		FlexItem,
		ProgressIndicator,
		Button } = Toolkit;


	class FlexSVGIcon extends React.Component{

		constructor(props){
			super(props);
		}
		render(){

			const { icon, title, onClick, type, ...others } = this.props;
			const className = `svgIcon visDT-ManageView-item visDT-ManageView-icon ${type}`;
			return (
				<FlexItem>
					<Container>
						<SVGIcon
							icon={icon}
							alt={title}
							ariaLabelledby={title}
							onClick={onClick}
							className={className}
							{...others}
						/>
					</Container>
				</FlexItem>
			);
		}
	}

	class FlexPadding extends React.Component{

		constructor(props){
			super(props);
		}
		render(){

			const { padding, ...others } = this.props;
			return (
				<FlexItem>
					<Container padding={padding} {...others}/>
				</FlexItem>
			);
		}
	}

	class DrillThroughManageComponents extends React.Component {

		constructor(props) {
			super(props);
			this.state = {
				...this.props,
				listData: [],
				visibleListData: [],
				isLoading: true,
				isClean: true
			};
			this.dialogProps = {
				size: 'small',
				width: '450px',
				maxWidth: '800px',
				clickaway: false
			};
		}

		componentDidMount() {
			this._updateData(true);
		}

		_updateData(isClean){

			//when isClean is undefined, we leave the current isClean state as it was
			isClean = isClean === undefined ? this.state.isClean: isClean;
			const _validSourceId = function(sources, id) {
				if (_.isArray(sources)) {
					for (let index = 0; index < sources.length; index++) {
						if (sources[index] === id) {
							return true;
						}
					}
				}
				return false;
			};
			const entries = this.props.drillThroughModelApi.getDrillDefinitionEntries(this.props.content);
			const visualizationAPI = this.props.content.getFeature('Visualization');
			const dataSource = visualizationAPI.getDataSource();
			const sourceId = dataSource.getId();
			const jumpToEntries = [];
			const iconsFeature = this.props.iconsFeature;
			const reportIcon = iconsFeature.getIcon('reportIcon');
			const dashboardIcon = iconsFeature.getIcon('dashboardIcon');
			const storyIcon = iconsFeature.getIcon('storyIcon');

			_.each(entries, function (entry) {
				if (_validSourceId(entry.getModelRefs(), sourceId)) {
					jumpToEntries.push({
						getIcon: function () {
							const iconMap = {
								authoring: reportIcon.id,
								story: storyIcon.id,
								dashboard: dashboardIcon.id
							};
							return iconMap[entry.getPerspective()];
						},
						getId: function () {
							return entry.getId();
						},
						getName: function () {
							return entry.getName();
						},
						editJumpTo: resources.get('drillthrough_manageJumpPaths_edit', {
							name: entry.getName()
						}),
						removeJumpTo: resources.get('drillthrough_manageJumpPaths_delete', {
							name: entry.getName()
						})
					});
				}
			});
			this.setState({ listData: jumpToEntries,
				visibleListData: jumpToEntries.slice(),
				isLoading: false ,
				isClean: !!isClean });
		}

		/**
		 * Stops the propagation of an event and applies the current drill through manage specification
		 * @param {object} evt
		 */
		_onApply(evt) {
			if (evt) {
				evt.stopPropagation();
			}

			this.props.applyDrillManage(this.state);
		}

		/**
		 * Stops the propagation of an event and removes the dialog
		 * @param {object} evt
		 */
		_onCancel(evt) {
			if (evt) {
				evt.stopPropagation();
			}
			this.props.onCancel();
		}

		_itemRenderer(index, props) {
			const { ...other } = props;
			const item = this.state.visibleListData[index];
			const iconsFeature = this.props.iconsFeature;
			const editIcon = iconsFeature.getIcon('common-edit');
			const removeIcon = iconsFeature.getIcon('remove');
			return (
				<ListItem {...other} data-index={index} className='visDT-ManageView-item-container' data-id={item.getId()}>
					<FlexSVGIcon icon={item.getIcon()} type='disable' />
					<FlexPadding padding={1} />
					<FlexItem grow className='visDT-ManageView-item visDT-ManageView-item-target'>
						<TruncatedText value={item.getName()} title={item.getName()} tabIndex='0'/>
					</FlexItem>
					<FlexPadding padding={1} />
					<FlexSVGIcon
						icon={editIcon}
						title={item.editJumpTo}
						type='edit'
						onClick={this._onEdit.bind(this)}
						onKeyUp= { event => {
							if (event.key === 'Enter') {
								this._onEdit(event);
							}
						}}
						role='button'
						tabIndex='0'
					/>

					<FlexPadding padding={1} />
					<FlexSVGIcon
						height={16}
						width={16}
						icon={removeIcon}
						title={item.removeJumpTo}
						type='delete'
						role='button'
						tabIndex='0'
						onClick={this._onDelete.bind(this)}
						onKeyUp= { event => {
							if (event.key === 'Enter') {
								this._onDelete(event);
							}
						}}/>
				</ListItem>
			);
		}

		_addNewItem(){
			const iconsFeature = this.props.dashboard.getFeature('Icons');
			let addAnotherJumpTo = resources.get('drillthrough_manageAddAnotherTarget');
			const addNewIcon = iconsFeature.getIcon('add16');

			const addNewTarget =  {
				getId: () => 'addNewTarget',
				getName: () => addAnotherJumpTo,
				getIcon: () =>  addNewIcon
			};
			return (
				<ListItem className='visDT-ManageView-item-container visDT-ManageView-add' onClick={this._onAddNewTarget.bind(this)} data-id={addNewTarget.getId()}>
					<Button
						label={addNewTarget.getName()}
						icon={addNewTarget.getIcon()}
						intent="primary"
						variant="frameless"
					/>
				</ListItem>
			);
		}

		_onEdit(event) {
			let id = this._getId(event);
			return id ? this.props.handlers.onEdit(this.props.content, id, this._getEditDrillThroughModelOptions()) : Promise.reject('Invalid drill through target');
		}

		_onDelete(event) {
			let id = this._getId(event);
			let drillTarget = id ? this.props.drillThroughModelApi.getDrillDefinitionEntry(id) : null;

			if (drillTarget) {
				let confirmDlg = new ConfirmationDialog({
					className: 'confirmDeleteDrillTarget',
					title:resources.get('drillthrough_manageConfirmeDeleteDrillTargetTitle'),
					message:resources.get('drillthrough_manageConfirmeDeleteDrillTarget', {
						name: drillTarget.getName()
					}),
					confirmCallback:() => {
						this.props.handlers.onDelete(id, this._getEditDrillThroughModelOptions());
					}
				});
				confirmDlg.render();
			} else {
				throw new Error('Invalid drill through target');
			}
		}

		_onAddNewTarget() {
			return this.props.handlers.onCreate(this.props.content, this._getEditDrillThroughModelOptions());
		}

		_getItem(event) {
			let $target = $(event.currentTarget);
			return $target.closest('.visDT-ManageView-item-container');
		}

		_getId(event) {
			let $ancestor = this._getItem(event);
			return ($ancestor.length > 0) ? $ancestor[0].getAttribute('data-id') : null;
		}

		_getEditDrillThroughModelOptions() {
			return {
				undoRedoOptions: {
					silent: true
				},
				callback: this._updateData.bind(this)
			};
		}


		render() {
			let listItems;
			if (!this.state.openDialog) {
				return null;
			}
			listItems = this.state.isLoading ?
				(<Container id='overlay'>
					<ProgressIndicator tabIndex={0} size='normal' />
				</Container>) :
				<Container className='visDT-ManageView-container'>
					<List
						length={this.state.visibleListData.length}
						itemRenderer={this._itemRenderer.bind(this)}
						fullHeight='true'
						className='visDT-ManageView-list'
						tabIndex='-1'
					/>
					{this._addNewItem()}
				</Container>;


			return(
				<Dialog
					{...this.dialogProps}
					onClose={this._onCancel.bind(this)}
				>
					<Container className='visDT-ManageView'>
						<Dialog.Header>
							<TruncatedText
								value={resources.get('drillthrough_manageJumpPaths', { 'drillthrough_manageJumpPaths': resources.get('drillthrough_manageJumpPaths'), 'name': this.props.label })}
							/>
						</Dialog.Header>
						<Dialog.Body>
							{listItems}
						</Dialog.Body>
						<Dialog.Footer>
							<Dialog.Button
								primary
								id='applyDrillManage'
								label={resources.get('dlg_apply')}
								title={resources.get('dlg_apply')}
								onClick={this._onApply.bind(this)}
								disabled={this.state.isClean}
							/>
							<Dialog.Button
								label={resources.get('dlg_cancel')}
								title={resources.get('dlg_cancel')}
								id='cancelDrillManage'
								onClick={this._onCancel.bind(this)}
							/>
						</Dialog.Footer>
					</Container>
				</Dialog>);

		}
	}

	FlexSVGIcon.propTypes={
		icon: PropTypes.object,
		title: PropTypes.string,
		onClick:PropTypes.func,
		type: PropTypes.string
	};

	FlexPadding.propTypes = {
		padding: PropTypes.number
	};

	DrillThroughManageComponents.propTypes = {
		label: PropTypes.string,
		openDialog: PropTypes.bool,
		applyDrillManage: PropTypes.func,
		onCancel: PropTypes.func,
		iconsFeature: PropTypes.object,
		content: PropTypes.object,
		dashboard: PropTypes.object,
		drillThroughModelApi: PropTypes.object,
		handlers: PropTypes.object
	};
	return DrillThroughManageComponents;
});
